
import { User } from 'src/models/user';
import { HelperService } from 'src/services/helperService';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatSelect as MatSelect } from '@angular/material/select';
import { MatOption as MatOption } from '@angular/material/core';

import { APIReportService } from 'src/services/api-services/api-reports-services';
import { catchError, Observable, reduce, tap, throwError } from 'rxjs';
import moment from 'moment';
import { labelFilter, reportDTO } from 'src/services/api-services/api-interfaces/api-reports-interface';

import { typeOfService } from '../../services/api-services/api-interfaces/typeOfService.interface';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.sass'],
    standalone: false
})
export class ReportsComponent implements OnInit {
  @ViewChild('selectBrand') selectBrand!: MatSelect;
  sumtotalColumn: any[]=[]
  rowTotals: any[]=[]
  total: any[] = [];
  indexbrand: number = 0;
  allowedRoles = [3, 4, 5];
  isDisabled = true;
  reportsList: Observable<any> =  new Observable<any>();
  dataCities: any= [];
  dataWorkshop: any = [];
  dataAdvisor: any = [];
  dataTypeOfService: any = [];
  dataFilterAdvisor:labelFilter={
  advisorFullName:"",
  advisorId:0,
  cityId:0,
  cityName:"",
  workshopId:0,
  workshopName:""
  };
  dataBrand: any = [];
  allBrandsSelected: boolean = false;
  brandsSelected: string = ''
  dataShow=[]
  textHeaders:string[]=[]
  cityId:number=0;
  workshopId: number = 0;
  advisorId?: number
  serviceId: number = 0;
  brandId: any = 0;
  reportId: number = 0;
  isVisibleExport:boolean=false;
  isVisibleTable:boolean=false;
  startDate: string = "";
  endDate: string = "";
  diccionary:reportDTO ={} as reportDTO;
  user: User=this.helperService.user
  reportName: string=''
  roleId: number=this.helperService.user.role.roleId
  retailId: number = this.helperService.user.retailId
  countryId: number = this.helperService.user.countryId
  userWorkshopId:number=this.helperService.user.workshopId
  userAdvisorId:number=this.helperService.user.advisorId
  userId:number=this.helperService.user.userid
  isLoading:boolean= false
  disableCity:boolean=false
  disableWorkshop:boolean=false
  disableAdvisor:boolean = false
  disableTypeOfServices:boolean=false
  disableBrands:boolean=false
  dataSearched = false;
  loading: boolean = true;
  isGridVisible: boolean = false;





  constructor(
    public helperService: HelperService,
    public ReportService : APIReportService,
    @Inject(LOCALE_ID)
    public localeId: string,
  ) {}

  ngOnInit(): void {
  //   this.ReportService?.gettoken()
  //   .pipe (tap(answer =>{
  //  console.log(answer)
  // })).subscribe()

    this.helperService.TitlePage = 'Reports'
    this.helperService.icon = "pie_chart_outline"
    this.reportsList= this.ReportService?.getReportsFilterDropDown(this.roleId).pipe(tap(()=>{this.loading= false}), catchError((error: any) => {
                   // Handle validation error here
                   if(error.status === 401){
                    this.helperService.logoutToken()
                  }
                 console.error('Validation Error:', error);
                 // Rethrow the error to propagate it downstream
                 return throwError(error);
                 }))
    const dropdowSize = "4%"
    document.documentElement.style.setProperty('--dropdow-Size', dropdowSize);

  }

  dateFilterEnd = (date): boolean  => {
    if(date >= this.startDate){
      return true;
    }
    else{
      return false;
    }
  }

  ChangeDateEnd() {
    if (this.startDate > this.endDate) {
      this.endDate = this.startDate;
    }
  }

  disableAllFilters(){
    if(this.reportId===15){
      this.disableCity=true
      this.disableWorkshop=true
      this.disableAdvisor=true
      this.disableTypeOfServices=true
      this.disableBrands=true
    } else{
      this.disableCity=false
      this.disableWorkshop=false
      this.disableAdvisor=false
      this.disableTypeOfServices=false
      this.disableBrands=false
      this.allBrandsSelected = true;
    }
  }

  selectAdvisor(){
    this.disableTypeOfServices = true
    this.disableBrands=true
    if(this.advisorId === 0){
      this.disableBrands=false;
      this.allBrandsSelected = true;
      this.disableTypeOfServices=false
    }

    if (this.roleId === 2|| this.roleId === 6) {
      this.disableBrands=false;
      this.allBrandsSelected = true;
      this.disableTypeOfServices=false
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.userWorkshopId,this.advisorId)
      .pipe (tap(answer =>{
      if(!answer.message){
      this.dataTypeOfService = answer[3]
      this.dataBrand = answer[4]
      this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
      this.toggleAllBrands();
      this.disableAllFilters()
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }
  }

  selectTypeOfService(){
    this.disableAdvisor = true
    this.disableBrands=true
    if (this.roleId === 2|| this.roleId === 6) {
      this.disableAdvisor = false
      this.disableBrands=true
    }
    if (this.serviceId === 0) {
      if (this.roleId === 4 || this.roleId === 5){
        this.disableAdvisor = true;
        this.disableBrands = false;
      } else {
        this.disableAdvisor = false;
        this.disableBrands = false;
      }
    }
  }

  // multiple selection brands logic
  toggleAllBrands() {
    if (this.allBrandsSelected) {
      this.selectAllBrands();
    } else {
      this.deselectAllBrands();
    }
  }

  selectBrands(){
    const allSelected = this.selectBrand.options
      .filter((item: MatOption) => item.value !== null)
      .every((item: MatOption) => item.selected);

    this.allBrandsSelected = allSelected;
    this.updateSelectedBrands();

    this.disableAdvisor = true
    this.disableTypeOfServices=true

    if (this.roleId === 2|| this.roleId === 6) {
      this.disableAdvisor = false
      this.disableTypeOfServices=true
    }

    if(this.brandsSelected === 'All'){
      this.disableAdvisor=false
      this.disableTypeOfServices=false
    }
  }

  updateSelectedBrands() {
    const selectedOptions = this.selectBrand.options
      .filter((item: MatOption) => item.selected && item.value !== null)
      .map((item: MatOption) => item.viewValue);

    if (this.allBrandsSelected) {
      this.brandsSelected = 'All';
      this.brandId = [...this.dataBrand.map((brand) => brand.brandId), 0];
    } else {
      this.brandsSelected = selectedOptions.join(', ');
      this.brandId = this.selectBrand.options
        .filter((item: MatOption) => item.selected && item.value !== null)
        .map((item: MatOption) => item.value);
    }
  }

  selectAllBrands() {
    setTimeout(() => {
      this.selectBrand.options.forEach((item: MatOption) => {
        if (item.value !== null) {
          item.select();
        }
      })
      this.brandsSelected = 'All';
      this.brandId = [...this.dataBrand.map((brand) => brand.brandId), 0];
      this.disableAdvisor=false
      this.disableTypeOfServices=false
    }, 0);
  }

  deselectAllBrands() {
    this.selectBrand.options.forEach((item: MatOption) => item.deselect());
    this.brandsSelected = '';
    this.brandId = [];
    this.disableAdvisor=true
      this.disableTypeOfServices=true
  }

  getNameCity(reportName:string){
    this.clearFilterReport()
    this.reportName= reportName;
    if (this.roleId === 3) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId)
      .pipe(tap(answer =>{
      if(!answer.message){
        this.dataCities = answer[1]
        this.isDisabled =false
        this.disableAllFilters()
      }

    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }if(this.roleId ===4){
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.retailId)
      .pipe(tap(answer =>{
      if(!answer.message){
        this.dataCities = answer[1]
        this.isDisabled =false
        this.disableAllFilters()
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }

    if(this.roleId ===5){
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.userId)
      .pipe(tap(answer =>{
      if(!answer.message){
        this.dataCities = answer[1]
        this.isDisabled =false
        this.disableAllFilters()
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }
    if (this.roleId === 1) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.userAdvisorId)
      .pipe(tap(answer =>{
      if(!answer.message){
        this.dataFilterAdvisor = answer[1][0]
        this.advisorId=this.dataFilterAdvisor.advisorId
        this.workshopId=this.dataFilterAdvisor.workshopId
        this.cityId=this.dataFilterAdvisor.cityId
        this.dataTypeOfService = answer[2]
        this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
        this.dataAdvisor.push({advisorId:0,advisorFullName:"All"})
        this.dataBrand = answer[3]
        this.toggleAllBrands();
        this.isDisabled =false
        this.disableAllFilters()
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }
    if (this.roleId === 2|| this.roleId === 6) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.userWorkshopId)
      .pipe (tap(answer =>{
      if(!answer.message){
        this.dataFilterAdvisor = answer[1][0]
        this.workshopId=this.dataFilterAdvisor.workshopId
        this.cityId=this.dataFilterAdvisor.cityId
        this.isDisabled =false
        this.dataAdvisor=answer[2]
        this.disableAllFilters()
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }
  }

  getWorkshop(cityId:number){
    this.cityId = cityId
    if (this.roleId ===4||this.roleId ===5) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.retailId,cityId)
      .pipe(tap(answer =>{
      if(!answer.message){
        this.dataWorkshop = answer[2]
        this.disableAdvisor=true
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }

    if (this.roleId ===3) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.cityId)
      .pipe(tap(answer =>{

      if(!answer.message){
        this.dataWorkshop = answer[2]
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }
  }


  getAdvisor(workshopId:number){
    this.workshopId = workshopId
    if(this.roleId === 2||this.roleId ===6){
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.workshopId,this.advisorId).pipe(tap (answer =>{
        if(!answer.message){
          this.dataAdvisor = answer[2]
          this.dataAdvisor.push({advisorId:0,advisorFullName:"All"})
          this.dataTypeOfService = answer[4]
          this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
          this.dataBrand=answer[5]
          this.toggleAllBrands();

       }
      }), catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
         this.helperService.logoutToken()
       }
      console.error('Validation Error:', error);
      // Rethrow the error to propagate it downstream
      return throwError(error);
      })).subscribe()

    }
    if (this.roleId ===4||this.roleId ===5 ) {
     this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.retailId,this.cityId,workshopId).pipe(tap (answer =>{
      if(!answer.message){
        this.dataAdvisor = answer[3]
        this.dataTypeOfService=answer[4]
        this.dataBrand=answer[5]
        this.disableAdvisor=true
        this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
        this.toggleAllBrands();
      }
    }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
    }

    if (this.roleId ===3 ) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.cityId,workshopId).pipe(tap (answer =>{
        if(!answer.message){
          this.dataAdvisor = answer[3]
          this.dataAdvisor.push({advisorId:0,advisorFullName:"All"})
          this.dataTypeOfService=answer[4]
          this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
          this.dataBrand=answer[5]
          this.toggleAllBrands();
        }
      }), catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
         this.helperService.logoutToken()
       }
      console.error('Validation Error:', error);
      // Rethrow the error to propagate it downstream
      return throwError(error);
      })).subscribe()
    }
  }

  getTypeOfService(advisorId:number){
    this.advisorId = advisorId
    if (this.roleId === 3) {
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.retailId,this.cityId,this.workshopId ).pipe(tap (answer =>{
       if(!answer.message){
        this.dataTypeOfService = answer[4]
        this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
      }
     }), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
     }


    if(this.roleId === 2||this.roleId ===6){
      this.ReportService?.getReportsFilterDropDown(this.roleId,this.countryId,this.workshopId,this.advisorId).pipe(tap (answer =>{
        if(!answer.message){
          this.dataAdvisor = answer[2]
          this.dataAdvisor.push({advisorId:0,advisorFullName:"All"})
          this.dataTypeOfService = answer[4]
          this.dataTypeOfService.push({serviceId:0,serviceName:"All"})
          this.dataBrand=answer[5]
          this.toggleAllBrands();
       }
      }), catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
         this.helperService.logoutToken()
       }
      console.error('Validation Error:', error);
      // Rethrow the error to propagate it downstream
      return throwError(error);
      })).subscribe()

    }
  }

  // is Export can be 0 or 1, 0 meaning getting the data on screen. 1 is to get the data as pdf
  searchReport(isExport:number){
    
    this.diccionary={
      pCityId:this.cityId.toString(),
      pWorkshopId:this.workshopId.toString(),
      pAdvisorId:(this.advisorId? this.advisorId.toString() : '0'),
      pBrandId:this.brandId.toString(),
      pServiceId:this.serviceId.toString(),
      pRetailId:(this.retailId ? this.retailId.toString() : '0'),
      pCountryId:(this.countryId ? this.countryId.toString() : '0'),
      pUserId:this.user.userid.toString(),
      pInitialDate:moment(this.startDate).format('YYYY-MM-DD'),
      pFinalDate:moment(this.endDate).format('YYYY-MM-DD'),
    }
    this.isLoading=true
    this.getReport(isExport)


  }

  isSearchDisable(): boolean{
    return !this.startDate || !this.endDate;
  }

  clearFilter(){
    this.reportId=0
    this.cityId=0
    this.workshopId=0
    this.advisorId=0
    this.brandId=0
    this.serviceId=0
    this.startDate=""
    this.endDate=""
    this.dataCities=[]
    this.dataWorkshop=[]
    this.dataAdvisor=[]
    this.dataTypeOfService=[]
    this.dataBrand=[]
    this.disableCity=false
    this.disableWorkshop=false
    this.disableAdvisor= false
    this.disableTypeOfServices=false
    this.disableBrands=false
    this.dataSearched=false
    this.isGridVisible= false
  }

  clearFilterReport(){
    this.cityId=0
    this.workshopId=0
    this.advisorId=0
    this.brandId=0
    this.serviceId=0
    this.startDate=""
    this.endDate=""
    this.dataCities=[]
    this.dataWorkshop=[]
    this.dataAdvisor=[]
    this.dataTypeOfService=[]
    this.dataBrand=[]

  }

  getReport(isExport:number){

    this.ReportService?.post(this.roleId,this.reportId,isExport,0,this.diccionary)

  .subscribe((blob:any)=>{
    this.dataSearched = true
    if (isExport===1) {
      this.isVisibleTable = true
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${this.reportName}_${this.diccionary.pInitialDate}_${this.diccionary.pFinalDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(downloadUrl);

    }, 100);
    }

    else{
      if(!blob.message){
      // se esta realizando la suma de los valores obtenidos
        this.dataShow=blob
        if(this.dataShow.length <= 0){
          this.isLoading = false;
          return ;
        }

        this.rowTotals = this.dataShow.map((item: any) => {
          const rowValues = Object.values(item);
          return rowValues.reduce((numero: number, numero2: unknown) => {
            if (typeof numero2 === "number") {
              return numero + numero2;
            }
            return numero; // Ignorar valores que no sean números
          }, 0);
        });

        this.sumtotalColumn= this.rowTotals.reduce((prev:number,next:number)=>prev+next, 0)

        this.textHeaders=Object.keys(this.dataShow[0])
        this.isVisibleExport=true
        this.isLoading=false

        this.total=[]
        this.textHeaders.forEach((element, index)=> {

          const SumaTotal =this.dataShow.map((item:any)=>item[element]);

          this.total[index] =SumaTotal.reduce((numero:number, numero2:number)=>numero+numero2, 0)
          if(String(this.total[index])){
            this.total[index]="Total"
          }
        });
        this.isGridVisible = true;
    }
  }})

  }
}
